import { render } from "./VotingView.vue?vue&type=template&id=5b6ef47f"
import script from "./VotingView.vue?vue&type=script&lang=js"
export * from "./VotingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__